import { Component } from 'react'
import { connect } from 'react-redux'
import { Modal } from 'reactstrap'
import PropTypes from 'prop-types'

import { LoadingSpinner } from '../../@paco/components'
import { PacoLogsModal, UserProfileCard } from '../../@paco/compositions'
import { ConnectedHelpTooltip, ConnectedPermissionsList, ConnectedUserCalendar } from '../../@paco/connectors'
import { transformLegacyResourceToPermissionGroup } from '../../@paco/entities/PermissionGroup/PermissionGroupTransformers'
import checkPermission from '../../@paco/helpers/permissions/checkPermission'
import trans from '../../@paco/helpers/trans'
import { deleteAbsence, patchAbsence } from '../../@paco/redux/absences/absencesActions'
import { setError as setAbsencesError } from '../../@paco/redux/absences/absencesReducer'
import { getEventLogsByEntityUuid } from '../../@paco/redux/eventLogs/eventLogsActions'
import {
    approveLeaveOfAbsence,
    declineLeaveOfAbsence,
    deleteLeaveOfAbsence,
    patchLeaveOfAbsence,
} from '../../@paco/redux/leaveOfAbsences/leaveOfAbsencesActions'
import { setError as setLeaveOfAbsencesError } from '../../@paco/redux/leaveOfAbsences/leaveOfAbsencesReducer'
import { getPacoPayrollPeriods } from '../../@paco/redux/payrollPeriods/payrollPeriodsActions'
import { setToast } from '../../@paco/redux/toasts/toastsReducer'
import { downloadYearEndStatement } from '../../@paco/redux/yearEndStatement/yearEndStatementActions'
import { ToastType } from '../../@paco/types'
import { RoleType } from '../../@paco/types/roleTypes'

import DeleteResourceForm from '../../components/forms/DeleteResourceForm/DeleteResourceForm'
import {
    HR,
    TYPE_ABSENCE,
    TYPE_LEAVE_OF_ABSENCE,
    TYPE_UNAVAILABLE_TO_WORK_TIME_SLOT,
} from '../../constants'
import { getObjProperty } from '../../helpers'
import { translate } from '../../helpers/translations/translator'
import { withRouter } from '../../helpers/WithRouter'
import { LeaveOfAbsenceEditType } from '../../models'
import { getPayrollPeriods } from '../../redux/app/appActions'
import {
    addUserDocument,
    editUserDocument,
    removeUserDocument,
} from '../../@paco/redux/files/filesActions'
import {
    deleteUserPlanningPreference,
    getPermissionGroups,
    linkUserToLoket,
    setUserPlanningPreference,
} from '../../redux/management/managementActions'
import {
    addUserNote,
    deleteUserNote,
    editUserNote,
    getUser,
} from '../../redux/management-ts/managementActions'
import DeclineLeaveOfAbsenceForm from '../Absences/forms/DeclineLeaveOfAbsenceForm'
import EditAbsenceForm from '../Absences/forms/EditAbsenceForm/EditAbsenceForm'
import ResolveLeaveOfAbsenceForm from '../Absences/forms/ResolveLeaveOfAbsenceForm/ResolveLeaveOfAbsenceForm'
import Absences from './components/Absences/Absences'
import Availability from './components/Availability/Availability'
import Contracts from './components/Contracts/Contracts'
import Couplings from './components/Couplings/Couplings'
import Documents from './components/Documents/Documents'
import Notes from './components/Notes/Notes'
import Satisfaction from './components/Satisfaction/Satisfaction'
import UserNavigation from './components/UserNavigation/UserNavigation'
import AddOrEditAvailabilityTime from './forms/AddOrEditAvailabilityTime/AddOrEditAvailabilityTime'
import AddOrEditDocument from './forms/AddOrEditDocument'
import DeleteDocumentForm from './forms/DeleteDocument'

import './User.scss'

export class User extends Component {
    constructor(props) {
        super(props)

        this.state = {
            addDocumentForm: false,
            deleteDocumentForm: false,
            deleteDocumentId: null,
            editDocumentData: null,
            activeLink: translate('nav.userManagement.users.personalData.link'),
            activeAbsence: null,
            resolveLOAForm: false,
            removeForm: false,
            editAbsenceForm: false,
            declineForm: false,
            unavailableWorkTimeSlotForm: false,
            unavailableWorkTimeSlotData: null,
            logsModal: false,
        }
    }

    componentDidMount() {
        const { location } = this.props
        const { search } = location
        const activeLink = search.substring(1)
        this.getUser()

        if (activeLink.length > 0) {
            this.setState({
                activeLink,
            })
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.leaveOfAbsencesError && this.props.leaveOfAbsencesError !== prevProps.leaveOfAbsencesError) {
            this.props.dispatch(setToast({
                text: this.props.leaveOfAbsencesError,
                type: ToastType.fail,
                shouldFadeOutAutomatically: false,
            }))

            this.props.dispatch(setLeaveOfAbsencesError(''))
        }

        if (this.props.absencesError && this.props.absencesError !== prevProps.absencesError) {
            this.props.dispatch(setToast({
                text: this.props.absencesError,
                type: ToastType.fail,
                shouldFadeOutAutomatically: false,
            }))

            this.props.dispatch(setAbsencesError(''))
        }
    }

    getUser = () => {
        const { dispatch, userId } = this.props

        dispatch(getUser(userId))
        dispatch(getPayrollPeriods())
        dispatch(getPacoPayrollPeriods())
        dispatch(getPermissionGroups())

        window.scrollTo(0, 0)
    }

    dispatchAddDocument = async (data) => {
        const { users } = this.props
        const { editDocumentData } = this.state
        const { user = null, dispatch } = this.props

        const hrUserIds = users
            .filter(usr => usr.roles.filter(role => role.slug === HR).length)
            .map(usr => usr.id)

        const fileFormData = {
            ...data,
            userId: user.id,
        }

        if (editDocumentData) {
            await dispatch(editUserDocument(
                data.id,
                fileFormData,
                hrUserIds,
                user.id,
                user.departments || [],
                user.roles || [],
            ))
        } else {
            await dispatch(addUserDocument(
                fileFormData,
                hrUserIds,
                user.id,
                user.departments || [],
                user.roles || [],
            ))
        }

        this.setState({
            addDocumentForm: false,
        })
    }

    dispatchOpenLogsModal = (id) => {
        this.props.dispatch(getEventLogsByEntityUuid(id))
        this.setState({
            logsModal: true,
        })
    }

    dispatchCloseLogsModal = () => {
        this.setState({
            logsModal: false,
        })
    }

    dispatchDeleteDocument = async (documentId) => {
        const { dispatch } = this.props
        await dispatch(removeUserDocument(documentId))
        this.setState({
            deleteDocumentForm: false,
        })

        // Refresh user data to get updated documents
        this.getUser()
    }

    dispatchLinkLoket = () => {
        const { dispatch, user = null } = this.props
        dispatch(linkUserToLoket(user.id))
    }

    dispatchEditLeaveOfAbsence = async (
        data,
        weeksWithHours,
        leaveType,
    ) => {
        const { activeAbsence } = this.state
        const { dispatch } = this.props

        this.setState({
            resolveLOAForm: false,
            activeAbsence: null,
        })

        await dispatch(patchLeaveOfAbsence(
            activeAbsence,
            data,
            activeAbsence.leaveOfAbsenceHours,
            weeksWithHours,
            leaveType,
        ))

        this.getUser()
    }

    dispatchApproveLeaveOfAbsence = async (
        data,
        weeksWithHours,
        leaveType,
    ) => {
        const { activeAbsence } = this.state
        const { dispatch } = this.props

        this.setState({
            resolveLOAForm: false,
            activeAbsence: null,
        })

        await dispatch(approveLeaveOfAbsence(
            activeAbsence,
            data,
            activeAbsence.leaveOfAbsenceHours,
            weeksWithHours,
            leaveType,
        ))

        this.getUser()
    }

    dispatchDeclineLeaveOfAbsence = async (declineComment) => {
        const { activeAbsence } = this.state
        const { dispatch } = this.props

        this.setState({
            resolveLOAForm: false,
            declineForm: false,
            activeAbsence: null,
        })

        await dispatch(declineLeaveOfAbsence(
            activeAbsence,
            declineComment,
        ))

        this.getUser()
    }

    dispatchEditAbsence = async (
        absence,
        data,
        weeksWithHours,
    ) => {
        const { dispatch } = this.props

        this.setState({
            editAbsenceForm: false,
        })

        await dispatch(patchAbsence(
            absence,
            data,
            absence.absenceHours,
            weeksWithHours,
        ))

        this.getUser()
    }

    dispatchRemoveLeaveOfAbsence = async () => {
        const { dispatch } = this.props

        this.setState({ removeForm: false })

        await dispatch(deleteLeaveOfAbsence(this.state.activeAbsence))

        this.getUser()
    }

    dispatchDeleteAbsence = async (absence) => {
        const { dispatch } = this.props

        this.setState({
            editAbsenceForm: false,
            activeAbsence: null,
        })

        await dispatch(deleteAbsence(absence))

        this.getUser()
    }

    dispatchSetPlanningPreference = (weekday, fromDate, toDate, comment, planningPreferenceId) => {
        const { user = null, dispatch } = this.props
        const { id: userId } = user
        const { unavailableWorkTimeSlotData } = this.state
        const id = unavailableWorkTimeSlotData ? unavailableWorkTimeSlotData.id : planningPreferenceId

        this.setState({
            unavailableWorkTimeSlotForm: false,
            unavailableWorkTimeSlotData: null,
        })

        dispatch(setUserPlanningPreference(
            weekday,
            fromDate,
            toDate,
            comment,
            userId,
            id,
        ))
    }

    dispatchDeletePlanningPreference = (planningPreferenceId) => {
        const { dispatch } = this.props
        dispatch(deleteUserPlanningPreference(planningPreferenceId))
    }

    onSubmitLeaveOfAbsenceForm = (
        editType,
        data,
        payrollPeriodsWithHours,
        weeksWithHours,
        leaveType,
    ) => {
        switch (editType) {
            case LeaveOfAbsenceEditType.deny:
                this.addDeclineLeaveOfAbsenceForm()
                break
            case LeaveOfAbsenceEditType.delete:
                this.setState({
                    removeForm: true,
                    resolveLOAForm: false,
                })
                break
            case LeaveOfAbsenceEditType.accept:
                this.dispatchApproveLeaveOfAbsence(
                    data,
                    weeksWithHours,
                    leaveType,
                )
                break
            default:
                this.dispatchEditLeaveOfAbsence(
                    data,
                    weeksWithHours,
                    leaveType,
                )
                break
        }
    }

    addDeclineLeaveOfAbsenceForm = () => {
        this.setState({
            resolveLOAForm: false,
            declineForm: true,
        })
    }

    onAddDocumentClick = () => {
        this.setState({
            addDocumentForm: true,
            editDocumentData: null,
        })
    }

    onEditDocumentClick = (data) => {
        this.setState({
            addDocumentForm: true,
            editDocumentData: data,
        })
    }

    onDeleteDocumentClick = (id) => {
        this.setState({
            deleteDocumentForm: true,
            deleteDocumentId: id,
        })
    }

    onDownloadYearEndStatementClick = (yearSelectOption) => {
        const { dispatch, yearEndStatements } = this.props

        const yearEndStatementsToDownload = yearEndStatements.filter(yearEndStatement => yearEndStatement.year.toString() === yearSelectOption.value)

        yearEndStatementsToDownload.map(givenYearEndStatement => dispatch(downloadYearEndStatement(givenYearEndStatement.employment.id, givenYearEndStatement.year)))
    }

    onLinkClick = (link) => {
        const { user = null } = this.props
        const pathBase = `/${translate('nav.userManagement.link')}`
        const pathUsers = `${pathBase}/${translate('nav.userManagement.users.link')}`
        window.history.pushState(link, link, `${pathUsers}/${user.id}?${link}`)

        this.setState({
            activeLink: link,
        })
    }

    onResourceClick = (resource) => {
        if (resource.type === TYPE_LEAVE_OF_ABSENCE) {
            this.setState({
                resolveLOAForm: true,
                activeAbsence: resource,
            })
        } else if (resource.type === TYPE_ABSENCE) {
            this.setState({
                editAbsenceForm: true,
                activeAbsence: resource,
            })
        } else if (resource.type === TYPE_UNAVAILABLE_TO_WORK_TIME_SLOT) {
            this.setState({
                unavailableWorkTimeSlotForm: true,
                unavailableWorkTimeSlotData: resource,
            })
        }
    }

    onAddNote = (formData) => {
        const { dispatch } = this.props
        dispatch(addUserNote(formData))
    }

    onEditNote = (formData) => {
        const { dispatch } = this.props
        dispatch(editUserNote(formData))
    }

    onDeleteNote = (formData) => {
        const { dispatch } = this.props
        dispatch(deleteUserNote(formData))
    }

    renderPersonalContent = () => {
        const { activeLink } = this.state
        const {
            userFiles,
            yearEndStatements,
            userNotes,
            legacyUserTracks,
            permissions,
            roles,
            userShifts,
            shiftsLoading,
            leaveOfAbsencesLoading,
            isUserTracksLoading,
            permissionGroups,
            commentCategories,
            user = null,
            legacyUser = undefined,
            userLoketHours = null,
            currentUser = null,
        } = this.props
        const sameUserAsCurrentUser = currentUser.id === user.id

        const canViewUserProfiles = checkPermission(permissions, 'view-all-user-profiles')
        const hasRoleToSeeAbsences = user.role.priority <= currentUser.role.priority
        const canViewAllAbsences = hasRoleToSeeAbsences && checkPermission(permissions, 'view-all-absences')

        switch (activeLink) {
            case translate('nav.userManagement.users.documents.link'):
                return (
                    <Documents
                        sameUserAsCurrentUser={sameUserAsCurrentUser}
                        userId={user.id}
                        files={userFiles}
                        yearEndStatements={yearEndStatements}
                        permissions={permissions}
                        onAddDocumentClick={this.onAddDocumentClick}
                        onDeleteDocumentClick={this.onDeleteDocumentClick}
                        onEditDocumentClick={this.onEditDocumentClick}
                        onDownloadYearEndStatementClick={this.onDownloadYearEndStatementClick}
                    />
                )
            case translate('nav.userManagement.users.contractInfo.link'):
                return <Contracts contracts={[]} />
            case translate('nav.userManagement.users.absences.link'):
                return (
                    <Absences
                        permissions={permissions}
                        roles={roles}
                        leaveOfAbsences={legacyUser?.leaveOfAbsences || []}
                        absences={legacyUser?.absences || []}
                        isLoading={leaveOfAbsencesLoading}
                        currentUser={currentUser}
                        userLoketHours={userLoketHours}
                        onAbsenceClick={this.onResourceClick}
                    />
                )
            case translate('nav.userManagement.users.couplings.link'):
                return (
                    <Couplings
                        onLinkLoketClick={this.dispatchLinkLoket}
                    />
                )
            case translate('nav.userManagement.users.calendar.link'):
                return (
                    <ConnectedUserCalendar
                        isLoading={shiftsLoading || isUserTracksLoading || leaveOfAbsencesLoading}
                        userId={user.id}
                        legacyUser={legacyUser}
                        shifts={userShifts}
                        onItemClick={this.onResourceClick}
                    />
                )
            case translate('nav.userManagement.users.permissions.link'):
                return (
                    <ConnectedPermissionsList
                        user={user}
                        permissionGroups={permissionGroups.map(transformLegacyResourceToPermissionGroup)}
                    />
                )
            case translate('nav.userManagement.users.unavailability.link'):
                return (
                    <Availability
                        loading={leaveOfAbsencesLoading}
                        permissions={permissions}
                        unavailableToWorkTimeSlots={legacyUser?.unavailableToWorkTimeSlots || []}
                        onSetPlanningPreference={this.dispatchSetPlanningPreference}
                        onDeletePlanningPreference={this.dispatchDeletePlanningPreference}
                    />
                )
            case translate('nav.userManagement.users.notes.link'):
                return (
                    <Notes
                        comments={userNotes}
                        commentCategories={commentCategories}
                        onAddNote={this.onAddNote}
                        onEditNote={this.onEditNote}
                        onDeleteNote={this.onDeleteNote}
                        userId={user.id}
                    />
                )
            case translate('nav.userManagement.users.satisfaction.link'):
                return (
                    <Satisfaction
                        tracks={legacyUserTracks}
                    />
                )
            default:
                return (
                    // eslint-disable-next-line no-nested-ternary
                    canViewUserProfiles ? (
                        <UserProfileCard user={user} />
                    ) : canViewAllAbsences ? (
                        <Absences
                            permissions={permissions}
                            roles={roles}
                            leaveOfAbsences={user.leaveOfAbsences}
                            absences={user.absences}
                            currentUser={currentUser}
                            userLoketHours={userLoketHours}
                            onAbsenceClick={this.onResourceClick}
                        />
                    ) : (
                        <Documents
                            sameUserAsCurrentUser={sameUserAsCurrentUser}
                            userId={user.id}
                            files={userFiles}
                            yearEndStatements={yearEndStatements}
                            permissions={permissions}
                            onAddDocumentClick={this.onAddDocumentClick}
                            onDeleteDocumentClick={this.onDeleteDocumentClick}
                            onEditDocumentClick={this.onEditDocumentClick}
                            onDownloadYearEndStatementClick={this.onDownloadYearEndStatementClick}
                        />
                    )
                )
        }
    }

    render() {
        const {
            activeLink,
            addDocumentForm,
            deleteDocumentForm,
            deleteDocumentId,
            editDocumentData,
            resolveLOAForm,
            removeForm,
            declineForm,
            editAbsenceForm,
            activeAbsence,
            unavailableWorkTimeSlotForm,
            unavailableWorkTimeSlotData,
        } = this.state
        const {
            loading,
            loadingDeletedAbsence,
            roles,
            permissions,
            documentTypes,
            pacoPayrollPeriods,
            payrollPeriods,
            user = null,
            currentUser = null,
            className = '',
            eventLogs,
            eventLogsLoading,
        } = this.props

        if (! user) {
            return (
                <div className={`legacy-user-detail-page ${className}`}>
                    <LoadingSpinner className="legacy-user-detail-page__loading-spinner" />
                </div>
            )
        }

        const isLoketAuthorized = getObjProperty(currentUser, 'isLoketAuthorized') ?? false
        const userIsEmployee = user.role.slug === RoleType.employee
        const existsInLoket = activeAbsence?.leaveOfAbsenceHours?.some((hours) => hours.loketIds?.length)

        return (
            <div className={`legacy-user-detail-page ${className}`}>
                <div className="legacy-user-detail-page-bottom">
                    <UserNavigation
                        activeLink={activeLink || undefined}
                        isLoketAuthorized={isLoketAuthorized}
                        permissions={permissions}
                        userId={user.id}
                        userRole={user.role}
                        currentUser={currentUser}
                        onLinkClick={this.onLinkClick}
                    />
                    <div className="legacy-user-detail-page__content-wrapper">
                        {! userIsEmployee && (
                            <ConnectedHelpTooltip
                                showMobileInfoWarning
                                index={1}
                                route="users-overview"
                                subTitle={trans('help.users.userAdditionalPermissions.title')}
                                text={trans('help.users.userAdditionalPermissions.text')}
                                title={trans('help.users.title')}
                                className="legacy-user-detail-page__user-additional-permissions-help-tooltip"
                            />
                        )}
                        <div className="legacy-user-detail-page-content">
                            {this.renderPersonalContent()}
                        </div>
                    </div>
                    {(loading || loadingDeletedAbsence) && <LoadingSpinner className="legacy-user-detail-page__loading-spinner" />}
                </div>
                <Modal size="lg" isOpen={addDocumentForm}>
                    <AddOrEditDocument
                        documentTypes={documentTypes}
                        document={editDocumentData}
                        onSubmit={this.dispatchAddDocument}
                        onCancel={() => this.setState({ addDocumentForm: false })}
                    />
                </Modal>
                <Modal size="lg" isOpen={deleteDocumentForm} className="form-delete-document">
                    <DeleteDocumentForm
                        onSubmit={() => this.dispatchDeleteDocument(deleteDocumentId)}
                        onCancel={() => this.setState({ deleteDocumentForm: false })}
                    />
                </Modal>
                <Modal size="lg" isOpen={resolveLOAForm} className="form-resolve-leave-of-absence">
                    {activeAbsence && (
                        <ResolveLeaveOfAbsenceForm
                            absence={activeAbsence}
                            permissions={permissions}
                            currentUserRole={currentUser.role}
                            pacoPayrollPeriods={pacoPayrollPeriods}
                            payrollPeriods={payrollPeriods}
                            onSubmit={this.onSubmitLeaveOfAbsenceForm}
                            onCancel={() => this.setState({ resolveLOAForm: false })}
                            onShowLogsClick={() => this.dispatchOpenLogsModal(activeAbsence.id)}
                        />
                    )}
                </Modal>
                <Modal size="lg" isOpen={declineForm} className="form-decline-leave-of-absence">
                    <DeclineLeaveOfAbsenceForm
                        onSubmit={this.dispatchDeclineLeaveOfAbsence}
                        onCancel={() => this.setState({ declineForm: false, activeAbsence: null })}
                    />
                </Modal>
                <Modal size="lg" isOpen={removeForm} className="form-decline-leave-of-absence">
                    <DeleteResourceForm
                        title={translate('pages.absences.deleteLeaveOfAbsence')}
                        intro={
                            existsInLoket
                                ? translate('pages.absences.deleteLeaveOfAbsenceWarningWithLoketInfo')
                                : translate('pages.absences.deleteLeaveOfAbsenceWarning')
                        }
                        onSubmit={() => this.dispatchRemoveLeaveOfAbsence(this.state.activeAbsence)}
                        onCancel={() => this.setState({ removeForm: false, activeAbsence: null })}
                    />
                </Modal>
                <Modal size="lg" isOpen={editAbsenceForm} className="form-edit-absence">
                    {activeAbsence && (
                        <EditAbsenceForm
                            data={activeAbsence}
                            permissions={permissions}
                            currentUserRole={roles}
                            pacoPayrollPeriods={pacoPayrollPeriods}
                            payrollPeriods={payrollPeriods}
                            onSubmit={this.dispatchEditAbsence}
                            onDelete={this.dispatchDeleteAbsence}
                            onCancel={() => this.setState({ editAbsenceForm: false })}
                        />
                    )}
                </Modal>
                <Modal size="lg" isOpen={unavailableWorkTimeSlotForm} className="form-add-time">
                    <AddOrEditAvailabilityTime
                        data={unavailableWorkTimeSlotData}
                        permissions={permissions}
                        onSubmit={this.dispatchSetPlanningPreference}
                        onCancel={() => this.setState({ unavailableWorkTimeSlotForm: false })}
                    />
                </Modal>
                <PacoLogsModal
                    isLoading={eventLogsLoading}
                    isOpen={this.state.logsModal && ! eventLogsLoading}
                    title={translate('logs.leaveOfAbsenceLog')}
                    emptyMessage={translate('logs.emptyLeaveOfAbsenceLog')}
                    logs={eventLogs}
                    onClose={this.dispatchCloseLogsModal}
                />
            </div>
        )
    }
}

User.propTypes = {
    location: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    user: PropTypes.object,
    legacyUser: PropTypes.object,
    isUserTracksLoading: PropTypes.bool.isRequired,
    userFiles: PropTypes.array.isRequired,
    yearEndStatements: PropTypes.array.isRequired,
    userShifts: PropTypes.array.isRequired,
    userLoketHours: PropTypes.object,
    userNotes: PropTypes.array.isRequired,
    legacyUserTracks: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    absencesError: PropTypes.string,
    leaveOfAbsencesError: PropTypes.string,
    shiftsLoading: PropTypes.bool.isRequired,
    documentTypes: PropTypes.array.isRequired,
    roles: PropTypes.array.isRequired,
    permissions: PropTypes.array.isRequired,
    permissionGroups: PropTypes.array.isRequired,
    commentCategories: PropTypes.array.isRequired,
    users: PropTypes.array.isRequired,
    pacoPayrollPeriods: PropTypes.array.isRequired,
    payrollPeriods: PropTypes.array.isRequired,
    currentUser: PropTypes.object,
    userId: PropTypes.string.isRequired,
    className: PropTypes.string,
}

function mapStateToProps(state) {
    return {
        loading: state.managementReducer.loading,
        loadingDeletedAbsence: state.absencesReducer.loading,
        absencesLoading: state.pacoAbsencesReducer.isLoading,
        leaveOfAbsencesLoading: state.pacoLeaveOfAbsencesReducer.isLoading,
        absencesError: state.pacoAbsencesReducer.error,
        leaveOfAbsencesError: state.pacoLeaveOfAbsencesReducer.error,
        shiftsLoading: state.managementReducer.shiftsLoading,
        filter: state.filterReducer.filter,
        currentUser: state.authenticatedUserReducer.user,
        user: state.pacoUserReducer.userProfile,
        legacyUser: state.managementReducer.user,
        isFullUserLoading: state.pacoUserReducer.isFullUserLoading,
        isUserTracksLoading: state.pacoUserReducer.isUserTracksLoading,
        userFormData: state.managementReducer.userFormData,
        userFiles: state.managementReducer.userFiles,
        yearEndStatements: state.managementReducer.yearEndStatements,
        userLoketHours: state.managementReducer.userLoketHours,
        users: state.managementReducer.users,
        userShifts: state.managementReducer.userShifts,
        userNotes: state.managementReducer.userNotes,
        userTracks: state.pacoUserReducer.userTracks,
        legacyUserTracks: state.managementReducer.userTracks,
        sorting: state.managementReducer.sorting,
        documentTypes: state.managementReducer.documentTypes,
        pagination: state.paginationReducer,
        roles: state.appReducer.roles,
        departments: state.authenticatedUserReducer.departments,
        permissions: state.authenticatedUserReducer.permissions,
        permissionGroups: state.managementReducer.permissionGroups,
        commentCategories: state.managementReducer.commentCategories,
        absences: state.absencesReducer.leaveOfAbsencesRequests,
        pacoPayrollPeriods: state.pacoPayrollPeriodsReducer.payrollPeriods,
        payrollPeriods: state.appReducer.payrollPeriods,
        exportCSVRequest: state.managementReducer.exportCSVRequest,
        eventLogs: state.eventLogsReducer.eventLogsByEntity,
        eventLogsLoading: state.eventLogsReducer.isLoading,
    }
}

export default withRouter(connect(mapStateToProps)(User))
